import {
  SubscriptionDetail,
  SubscriptionSummary,
  Res,
} from 'common/types/responses'
import dataRelay from 'data-relay'
import { Project } from 'common/project'

export type TrackableSubscription =
  | SubscriptionDetail
  | SubscriptionSummary
  | { product_id: number; [key: string]: any }

export function getEventData(sub: TrackableSubscription, user: Res['user']) {
  const planId = 'plan_id' in sub ? Number(sub.plan_id) : sub.product_id
  const plan = user?.products.find((p) => p.id === planId)
  const eventData = {
    event: 'Sale',
    propertyString1: 'INVOICE',
    propertyString2: plan?.billing_period === 2 ? 'year' : 'month',
    propertyString3: `${user.tenant_id}`,
    sku: plan?.name,
    source: user.partner_name,
    total:
      !!plan &&
      (plan?.billing_period === 2 ? (plan.cost / 12) * 100 : plan.cost * 100),
  }
  return eventData
}

export function trackCancelSubscription(
  data: TrackableSubscription,
  user: Res['user'],
) {
  try {
    if (!Project.dataRelay) return
    const eventData = getEventData(data, user)
    dataRelay.sendEvent(
      {
        ...eventData,
        event: 'Cancel',
        total: -(eventData.total || 0),
      },
      { apiKey: Project.dataRelay },
    )
  } catch (e) {}
}

export default function (data: TrackableSubscription, user: Res['user']) {
  try {
    if (!Project.dataRelay) return
    const eventData = getEventData(data, user)
    dataRelay.sendEvent(eventData, { apiKey: Project.dataRelay })
  } catch (e) {}
}
